import { render, staticRenderFns } from "./AscUserProfileTemplate.vue?vue&type=template&id=49f43d52&"
import script from "./AscUserProfileTemplate.vue?vue&type=script&lang=js&"
export * from "./AscUserProfileTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AscUserProfileTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports